import script from "./PatientCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientCard.vue?vue&type=script&setup=true&lang=js"

import "./PatientCard.vue?vue&type=style&index=0&id=02e22d82&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02e22d82"]])

export default __exports__